module.exports = __webpack_public_path__ + "img/gh.b1a97938.svg";